import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ListViewContainer = styled.div`
  height: calc(100% - 40px);
`;

export const LabelContainer = styled.div`
  height: 100%;
  min-width: 115px;

  display: flex;
  align-items: center;

  padding: 5px 0px;
  margin-left: 2px;
`;
